import React, { useState, useEffect } from 'react';

import { useParams, useLocation, useHistory } from 'react-router-dom';
import moment from 'moment';
import Select from 'react-select';
import { years } from '../../../../helpers';
import YearSelect from '../../../common/YearSelect';

import DownloadLink from '../../../common/DownloadLink';
import TableRid from './TableRid';
import CreateRid from '../../../project/Widgets/Requests/CreateRid';
import { status_ru_f } from '../../../../helpers/factdata';

const options = [
  { value: '', label: 'Все статусы' },
  ...Object.entries(status_ru_f).map(([key, value]) => ({ value: key, label: value })),
];

export default function RidTab({ portfName }) {
  const location = useLocation();
  const history = useHistory();
  const [year, setYear] = useState('Не указан');
  const { stratId, portfolioId } = useParams();
  const [showCard, setShowCard] = useState(false);
  const [editID, setEditID] = useState(null);
  const [filterStatus, setFilterStatus] = useState(options[0]);

  useEffect(async () => {
    if (location.search.includes('?card=1')) setShowCard(true);
    else setShowCard(false);
  }, [location.search]);

  if (showCard) {
    return (
      <CreateRid
        onHide={() => {
          history.goBack();
          setEditID(null);
        }}
        editID={editID}
      />
    );
  }

  return (
    <div>
      <div style={styledContainer} className="d-flex flex-wrap align-items-end">
          <div style={{minWidth: "144px"}}>
            <div style={{ color: "black", fontSize: "16px", marginBottom: "10px", fontWeight: "600" }}>Год</div>
            <YearSelect
              year={year}
              years={['Не указан', ...years.filter((e) => e != 2021)]}
              onChange={(e) => setYear(e.value)}
            />
          </div>
          <div style={{ minWidth: '200px', marginLeft: '16px' }}>
            <div style={{
              color: 'black', fontSize: '16px', marginBottom: '10px', fontWeight: '600',
            }}
            >
              Статус
            </div>
            <Select
              defaultValue={filterStatus}
              options={options}
              onChange={(e) => {
                setFilterStatus(e);
              }}
            />
          </div>
        <div style={{ marginLeft: "16px" }}>
          <DownloadLink
            variant="outline-primary"
            url={`/factdata/requests/0/export?type=rid&portfId=${portfolioId}`}
            filename={`Заявки на РИД портфель проектов (${portfName || ' '})_${moment().format('DD.MM.yyyy')}.xlsx`}
          >
            Выгрузить в xls
          </DownloadLink>
        </div>
      </div>
      <TableRid
        year={year}
        filterStatus={filterStatus.value}
        setEditID={(id) => {
          history.push(`${location.pathname}?card=1`);
          setEditID(id);
        }}
      />
    </div>
  );
}

const styledContainer = {
  display: 'flex',
  zIndex: 21,
  position: 'relative',
  top: 70,
  marginTop: -70,
  marginBottom: '20px',
};
